import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import brand1 from '../../images/brand-1.png'
import brand2 from '../../images/brand-2.png'
import brand3 from '../../images/brand-3.png'
import brand4 from '../../images/brand-4.png'

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import BrandCard from './BrandCard';
import { Tabs, Button } from 'antd';

const { TabPane } = Tabs;


SwiperCore.use([Navigation]);

const viewAll = <Button type="primary" >View All</Button>;
const swiperParams = {
    slidesPerView: 2,
    centeredSlides: false,
    loop: false,
    spaceBetween: 20,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
        900: {
            slidesPerView: 6,
        },
        700: {
            slidesPerView: 5,
        }
    },
}

function BrandSlider() {
    return (
        <div className="">
            <Swiper
                {...swiperParams}
                navigation={true}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
            >

                <SwiperSlide key="1">
                    <BrandCard url={brand1} name="Mahindra" />
                </SwiperSlide>

                <SwiperSlide key="2">
                    <BrandCard url={brand2} name="John Deer" />
                </SwiperSlide>
                
                <SwiperSlide key="3">
                    <BrandCard url={brand3} name="John Deer"/>
                </SwiperSlide>

                <SwiperSlide key="4">
                    <BrandCard url={brand4} name="John Deer"/>
                </SwiperSlide>

                <SwiperSlide key="5">
                    <BrandCard url={brand1} name="Mahindra"/>
                </SwiperSlide>
                
                <SwiperSlide key="6">
                    <BrandCard url={brand2} name="John Deer"/>
                </SwiperSlide>

                <SwiperSlide key="7">
                    <BrandCard url={brand3} name="John Deer"/>
                </SwiperSlide>

                <SwiperSlide key="8">
                    <BrandCard url={brand4} name="John Deer"/>
                </SwiperSlide>
                
                <SwiperSlide key="9">
                    <BrandCard url={brand1} name="Mahindra"/>
                </SwiperSlide>

            </Swiper>
            
        </div>
    );
}

export default BrandSlider;
